export interface IUsersEventStream {
	action: UsersEventType;
	users?: IManagedUser[];
}

export enum UsersEventType {
	loaded = 'loaded'
}

export interface IUsersSearchResults {
	cnt: number; // this the count of the total number of records which matched the search
	offset: number; // is the starting index from which results are returned (current page)
	nextPageToken?: string; // is the token to be used for fetching the next page of results when searching by role
	previousPageToken?: string; // is the token to be used for fetching the previous page of results when searching by role
	currentPageToken?: string; // is the token that was used for fetching the current page of results when searching by role
	currentPageForward?: boolean; // the page direction that was used for the current page of results when searching by role
	results: IManagedUser[];
}

export interface IUsersSearchQuery extends IUserSearchFields {
	pageSize: number;
	pageNumber: number;
	sortColumn: string;
	sortOrder: string;
}

export interface IUserSearchFields {
	query: { [key: string]: string | boolean };
	ranges: { [key: string]: string[] | number[] };
	createdTimezone: string;
	loginTimezone: string;
	emailVerified: string;
	gender: string;
	role: string;
	billingCountry: string;
}

export interface IUserTerms {
	termsId: string;
	displayName: string;
	companyId: string;
	versions: {
		[version: string]: {
			version: number;
			ts: number;
			clientId: string;
			url?: string;
			displayVersion: string;
		};
	};
}

export interface IUsersServiceData {
	results: IUsersSearchResults;
	terms: { [clusterId: string]: { [userId: string]: IUserTerms[] } };
}

export interface IManagedUser {
	id: number;
	email: string;
	uuid: string;
	clientId: string;
	dob: number;
	avatar: string;
	dobDayOfYear: number;
	dobMonth: number;
	dobDayOfMonth: number;
	dobYear: number;
	height: number;
	weight: number;
	gender: string;
	validated: boolean;
	suspended: boolean;
	optInMask: number;
	firstname: string;
	lastname: string;
	locale: string;
	timezone: string;
	country: string;
	state: string;
	locality: string;
	createdTime: number;
	metric: string;
	billingCountry: string;
	lastLogin: number;
	tns: { [key: string]: string };
	addresses: {
		[key: string]: {
			street: string;
			city: string;
			state: string;
			zip: string;
			country: string;
			'_country-display'?: string;
		};
	};
	attsMask: number;
	prefsMask: number;
	ridesMask: number;
	identities?: { [key: string]: string };
}

export interface IManagedUserUpdate {
	firstname?: string;
	lastname?: string;
	height?: number;
	weight?: number;
	gender?: string;
	dob?: number;
	avatar?: string;
	tns?: { [key: string]: string };
	addresses?: {
		[key: string]: {
			street: string;
			city: string;
			state: string;
			zip: string;
			country: string;
		};
	};
	timezone?: string;
	locale?: string;
	metric?: string;
	billingCountry?: string;
	country?: string;
	state?: string;
	locality?: string;
	prefsMask?: number;
	attsMask?: number;
	optInMask?: number;
	ridesMask?: number;
	identities?: {};
}

export interface IRole {
	roleId: string;
	desc: string;
}

export interface IAvailableRoles {
	canAdd: string[],
	canRemove: string[]
}

export interface IUserRoleSources {
  cognito: string[];
  dynamoDBUserRole: string[];
  dynamoDBUserIdentityMap: string[];
  sis: string[];
}


export enum UsersStorageKeys {
	usersSearchQuery = 'usersSearchQuery'
}

/**
 * UsersPrefsMask provides the order and mapping for the prefsMask
 * bitmask. Use bitmask-utility.services.ts for working with these values
 * and IUsersPrefsMask for Object creation from the mapping.
 */
export const UsersPrefsMask = [
	'activitysummary',
	'notifyonupload',
	'singlepage',
	'trainmyself',
	'havecoach',
	'iscoach',
	'compliancedurationdisabled',
	'compliancedistancedisabled',
	'compliancetscoredisabled',
	'ccpa',
	'notrack'
];

export interface IUsersPrefsMask {
	activitysummary: boolean;
	notifyonupload: boolean;
	singlepage: boolean;
	trainmyself: boolean;
	havecoach: boolean;
	iscoach: boolean;
	compliancedurationdisabled: boolean;
	compliancedistancedisabled: boolean;
	compliancetscoredisabled: boolean;
	ccpa: boolean;
	notrack: boolean;
}

export const OptInMask = ['mff', 'roval', 'specialized', 'retul', 'app'];

export interface IOptInMask {
	mff: boolean;
	roval: boolean;
	specialized: boolean;
	retul: boolean;
}

export const RidesMask = [
	'mountain',
	'road',
	'fitness',
	'adventureOrTour',
	'dirtOrPark',
	'cyclocross',
	'casualOrCommute',
	'downhill',
	'triathlon',
	'pedalAssist'
];

export interface IRidesMask {
	mountain: boolean;
	road: boolean;
	fitness: boolean;
	adventureOrTour: boolean;
	dirtOrPark: boolean;
	cyclocross: boolean;
	casualOrCommute: boolean;
	downhill: boolean;
	triathlon: boolean;
	pedalAssist: boolean;
}
